import type { ReactNode } from "react"
import { forwardRef } from "react"

import { Box, type BoxProps, type StackProps } from "@mui/material"
import type { EmblaViewportRefType } from "embla-carousel-react"
import type { FC } from ".."

interface CarouselProps extends StackProps {
  containerProps?: BoxProps
  viewportProps?: BoxProps
  carouselRef?: EmblaViewportRefType
  actions?: ReactNode
}

const CarouselRoot = forwardRef<HTMLDivElement, CarouselProps>(
  (
    {
      actions,
      carouselRef,
      containerProps,
      viewportProps,
      children,
      position = "relative",
      ...props
    },
    ref
  ) => {
    return (
      <Box
        position={position}
        overflow="hidden"
        sx={{ isolation: "isolate" }}
        className="e-carousel"
        {...containerProps}
      >
        <Box
          ref={carouselRef}
          className="e-carousel__viewport"
          px={{ xs: 4, sm: 5 }}
          {...viewportProps}
        >
          <Box display="flex" className="e-carousel__container" ref={ref} {...props}>
            {children}
          </Box>
        </Box>
        {actions}
      </Box>
    )
  }
)
CarouselRoot.displayName = "CarouselRoot"

type CarouselSlide = FC<BoxProps>

export const CarouselSlide: FC<BoxProps> = (props) => (
  <Box className="e-carousel__slide" flex="0 0 100%" minWidth={0} {...props} />
)

export const Carousel = {
  Root: CarouselRoot,
  Slide: CarouselSlide,
}
